import { SVGIconComponent } from './types';

export const OutboundMail: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="34px"
    height="34px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Type/Outbound-Mail" stroke="none" strokeWidth="1" fill="currentColor" fillRule="nonzero">
      <g id="Mail,-Collect" transform="translate(1.000000, 1.000000)">
        <path
          d="M11.1106,11.9388 C10.6367,11.9388 10.2526,11.557 10.2526,11.086 L10.2526,0.85277 C10.2526,0.3818 10.6367,0 11.1106,0 C11.5845,0 11.9686,0.3818 11.9686,0.85277 L11.9686,11.086 C11.9686,11.557 11.5845,11.9388 11.1106,11.9388 Z"
          id="Path"
        ></path>
        <path
          d="M14.2914,4.01407 C13.9563,4.3471 13.413,4.3471 13.078,4.01407 L11.1106,2.05876 L9.1433,4.01407 C8.80819,4.3471 8.26492,4.3471 7.92984,4.01407 C7.59477,3.68104 7.59477,3.1411 7.92984,2.80808 L10.5039,0.24977 C10.839,-0.083255 11.3822,-0.083255 11.7173,0.24977 L14.2914,2.80808 C14.6265,3.1411 14.6265,3.68105 14.2914,4.01407 Z"
          id="Path"
        ></path>
        <path
          d="M7.05805,7.82371 C7.05805,7.3526 6.67348,6.97069 6.19908,6.97069 L2.32709,6.97069 C1.7099,6.97069 1.11801,7.21389 0.68159,7.6468 C0.24518,8.0797 0,8.66684 0,9.2791 L0,19.9516 C0,20.5638 0.24518,21.151 0.68159,21.5839 C1.11801,22.0168 1.7099,22.26 2.32709,22.26 L20.0666,22.26 C20.6594,22.26 21.2278,22.0264 21.6469,21.6107 C21.8009,21.4579 21.9735,21.2658 22.0945,21.0104 C22.2214,20.7425 22.26,20.4739 22.26,20.2084 L22.26,9.2791 C22.26,8.66684 22.0148,8.0797 21.5784,7.6468 C21.142,7.21389 20.5501,6.97069 19.9329,6.97069 L16.3324,6.97069 C15.858,6.97069 15.4734,7.3526 15.4734,7.82371 C15.4734,8.29482 15.858,8.67673 16.3324,8.67673 L19.0704,8.67673 L11.1301,14.9782 L3.1897,8.67673 L6.19908,8.67673 C6.67348,8.67673 7.05805,8.29482 7.05805,7.82371 Z M11.6673,16.7367 L20.5401,9.6951 L20.5401,20.2084 C20.5401,20.2539 20.5371,20.2781 20.5355,20.2882 C20.527,20.3005 20.5005,20.3352 20.4308,20.4043 C20.3342,20.5001 20.2032,20.554 20.0666,20.554 L16.4004,20.554 C16.3522,20.554 16.3049,20.5579 16.2588,20.5655 L10.9492,20.5655 C10.903,20.5579 10.8556,20.5539 10.8073,20.5539 L2.32709,20.5539 C2.16605,20.5539 2.01161,20.4905 1.89773,20.3775 C1.78386,20.2645 1.71988,20.1113 1.71988,19.9516 L1.71988,9.6951 L10.5928,16.7367 C10.9069,16.986 11.3532,16.986 11.6673,16.7367 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);
